<template>
  <div>
    <div>
      <div>
        <div style="height: 32px;margin-bottom: 8px;display: flex;justify-content: space-between">
          <div style="display: inline-block;margin-left: 8px;margin-right: 5px;">
            <el-select v-model="initPage.platform" multiple placeholder="选择饰品平台" size="small" ref="platformSelect"
                       style="width: 180px" filterable clearable collapse-tags>
              <div style="height: 32px;display: flex;align-items: center" v-show="game === 'csgo'">
                <div style="font-size: 13px;margin-left: 12px">
                  支付方式:
                </div>
                <el-tag size="small" style="margin-left: 8px" type="info" class="hoverBtn"
                        @click="choosePlatform(['BUFF', 'C5Game', 'IGXE', 'UUPIN', 'V5Item','Eco', 'SkinPort','DMarket','CsMoney'])">
                  <svg style="vertical-align: -15%;" t="1720962737745" class="icon" viewBox="0 0 1024 1024"
                       version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="4250" width="16" height="16">
                    <path
                      d="M1023.795 853.64v6.348a163.807 163.807 0 0 1-163.807 163.807h-696.18A163.807 163.807 0 0 1 0 859.988v-696.18A163.807 163.807 0 0 1 163.807 0h696.181a163.807 163.807 0 0 1 163.807 163.807V853.64z"
                      fill="#009FE9" p-id="4251"></path>
                    <path
                      d="M844.836 648.267c-40.952-14.333-95.623-34.809-156.846-57.128a949.058 949.058 0 0 0 90.094-222.573H573.325V307.14h245.711v-43.41l-245.71 2.458V143.33H472.173c-18.223 0-21.704 20.476-21.704 20.476v102.38H204.759v40.952h245.71v61.427H245.712v40.952h409.518a805.522 805.522 0 0 1-64.909 148.246c-128.384-42.795-266.186-77.604-354.233-55.08a213.564 213.564 0 0 0-112.003 63.27c-95.418 116.917-26.21 294.034 175.274 294.034 119.989 0 236.087-67.366 325.771-177.73 134.322 65.932 398.666 176.297 398.666 176.297V701.3s-32.352-4.095-178.96-53.033z m-563.702 144.97c-158.893 0-204.759-124.699-126.336-194.112a191.86 191.86 0 0 1 90.913-46.276c93.575-10.238 189.811 35.629 293.624 86.614-74.941 94.598-166.674 153.774-258.2 153.774z"
                      fill="#FFFFFF" p-id="4252"></path>
                  </svg>
                  支付宝
                </el-tag>
                <el-tag size="small" style="margin-left: 8px" type="info" class="hoverBtn"
                        @click="choosePlatform(['BUFF','LisSkins','DMarket','SkinPort','CsMoney','Waxpeer','SkinBaron'])">
                  <svg style="vertical-align: -15%" t="1720963043575" class="icon" viewBox="0 0 3167 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="4862" width="16" height="16">
                    <path
                      d="M2959.856902 17.54821h-200.15157c-72.06992 0.159942-104.314251 21.848094-132.464065 89.023784l-284.217149 678.954304c-30.420991 72.709688-60.29818 145.611307-91.262974 220.528196h265.823805l53.228738-144.651654h329.480769c10.716122 48.71837 21.368267 96.701006 31.988424 144.651654h233.515497a2604751.293626 2604751.293626 0 0 0-205.877498-988.442307z m-315.66177 639.768484l130.544759-361.469194 8.796817 0.735734 75.012854 360.573517zM931.470924 18.667805L670.157487 680.156428c-2.367143 0-4.734287 0.255907-7.069442 0.319885-2.463109-10.204307-5.310078-20.376626-7.293361-30.804853-33.331938-177.599731-66.312003-355.263439-100.059791-532.799193a114.102709 114.102709 0 0 0-112.66323-99.164115C298.100125 16.108731 153.000633 17.164349 8.444944 17.164349a25.36682 25.36682 0 0 0-6.397685 28.021859 1373.87083 1373.87083 0 0 1 230.316654 75.268762 134.575301 134.575301 0 0 1 79.043396 97.020891c47.534798 188.923633 96.637029 377.463405 145.3554 566.195108 19.193055 75.012855 38.993889 149.929744 58.314897 223.918969h270.750023L1199.054092 18.667805zM2149.622106 479.045206a778.790175 778.790175 0 0 0-108.760643-65.896154 516.037259 516.037259 0 0 1-111.223751-68.263298 65.032466 65.032466 0 0 1 9.980389-112.183403 188.507784 188.507784 0 0 1 97.532705-27.158172 528.736663 528.736663 0 0 1 226.54202 45.007713l43.504257-206.581244A662.160381 662.160381 0 0 0 1977.044557 6.288284a455.835045 455.835045 0 0 0-215.761921 82.466158c-136.174722 98.46037-194.617573 322.091443 4.06253 451.836492 30.580934 19.960777 62.793277 37.330491 94.493805 55.467927 27.637998 15.770293 56.619511 29.461339 83.169903 46.799065a87.456352 87.456352 0 0 1 50.765629 86.368745 94.909655 94.909655 0 0 1-71.846001 75.012855 339.6211 339.6211 0 0 1-157.31907 10.844076 584.396522 584.396522 0 0 1-186.716432-58.47484l-45.807423 214.610338a803.389274 803.389274 0 0 0 372.793095 47.758717 458.394119 458.394119 0 0 0 262.656951-111.191762 276.124078 276.124078 0 0 0-17.881529-428.836815zM1311.109542 18.603828c-70.566464 330.47241-140.589124 658.769608-211.091611 988.698215h254.595868L1565.321549 18.475874z"
                      fill="#142C97" p-id="4863"></path>
                  </svg>
                  VISA
                </el-tag>
              </div>
              <el-option
                style="font-size: 12px"
                v-for="item in switchPlatformOptions()"
                :key="item.optionValue"
                :label="item.optionKey"
                :value="item.optionValue"
                :disabled="item.disabled"
              >
                <div style="display: flex;justify-content: space-between" @mouseenter="hoverPlatform(item.optionValue)">
                  <div>{{ item.optionKey }}</div>
                  <div @click.stop="choosePlatform(item.optionValue)"
                       v-show="activePlatform === item.optionValue"
                       style="color: #8492a6; font-size: 12px;">仅
                  </div>
                </div>
              </el-option>
            </el-select>
            <el-select v-show="game == 'csgo'" v-model="initPage.weaponCase" multiple :placeholder="$t('WeaponCase')"
                       size="small"
                       clearable filterable collapse-tags style="width: 260px;display: inline-block">
              <el-option
                style="font-size: 12px"
                v-for="item in weaponCasesOptions"
                :key="item.optionKey"
                :label="formatterLocalOption(item)"
                :value="item.optionKey">
              </el-option>
            </el-select>
            <el-select v-show="game == 'csgo'" style="width: 121px" size="small" filterable clearable @change="queryItemList"
                       :placeholder="$t('Exterior')"
                       v-model="initPage.wearType">
              <el-option
                v-for="item in wearTypeOptions"
                :key="item.optionKey"
                :label="$t(item.optionKey)"
                :value="item.optionKey"
              >
                <div :style="item.optionColor"
                     style="margin-right: 8px;display: inline;color: white;padding: 2px;min-width: 4px">
                </div>
                <div style="display: inline">
                  {{ $t(item.optionKey) }}
                </div>
              </el-option>
            </el-select>
            <el-select v-show="game == 'csgo'" style="width: 121px" size="small" filterable clearable @change="queryItemList"
                       :placeholder="$t('Rarity')"
                       v-model="initPage.rarityName">
              <el-option
                v-for="item in rarityOptions"
                :key="item.rarity"
                :value="item.rarityName"
                :label="formatterLocalRarityName(item)"
              >
                <span :style="`color:${item.color};font-size:12px`">{{ formatterLocalRarityName(item) }}</span>
              </el-option>
            </el-select>
            <el-select v-show="game == 'csgo'" style="width: 110px" size="small" filterable clearable @change="queryItemList"
                       v-model="initPage.quality">
              <el-option :key="0" label="普通" :value="0">{{ $t('Normal') }}</el-option>
              <el-option :key="1" label="纪念品" :value="1">{{ $t('Souvenir') }}</el-option>
              <el-option :key="2" label="StatTrak" :value="2">{{ $t('StatTrak™') }}</el-option>
              <el-option :key="3" label="★" :value="3">★ StatTrak™</el-option>
              <el-option :key="4" label="★" :value="4">★</el-option>
            </el-select>
            <el-select
              @change="queryItemList"
              v-show="game == 'csgo'"
                       style="width: 110px"
                       size="small"
                       filterable
                       clearable
                       :placeholder="$t('Category')"
                       v-model="initPage.category">
              <el-option v-for="category of categoryOptions" :key="category.optionKey" :label="category.optionValue" :value="category.optionValue"></el-option>
            </el-select>
          </div>
          <div style="text-align: right;align-items: center;display: flex">
            <el-autocomplete
              style="flex: 1;width: 600px"
              size="small"
              :trigger-on-focus="false"
              v-model="initPage.name"
              :fetch-suggestions="remoteMethod"
              :placeholder="$t('pleaseInput')"
              @keydown.native="onKeyDown"
              @select="clickRemoteOption"
            ></el-autocomplete>
          </div>
        </div>
        <div style="height: 32px;margin-bottom: 12px;display: flex;justify-content: space-between">
          <div style="display: inline-block;margin-left: 8px;margin-right: 5px">
            <div v-show="game == 'csgo'" style="display: flex;align-items: center">
              <el-tag style="margin-right: 8px;background-color:white;border-color:white">快捷筛选</el-tag>
              <el-tag style="margin-right: 8px" class="hoverBtn" type="info" @click="myfavors()">
                我的收藏
              </el-tag>
              <el-tag style="margin-right: 8px" class="hoverBtn" type="info" @click="fillDefaultSearchForm()">
                武器箱数据
              </el-tag>
              <el-tag style="margin-right: 8px" class="hoverBtn" type="info" @click="fillAgentSearchForm()">
                探员数据
              </el-tag>
              <el-tag style="margin-right: 8px" class="hoverBtn" type="info" @click="fillDefaultSearchForm2()">
                胶囊数据
              </el-tag>
            </div>
          </div>
          <div style="display: flex;">
            <div style="display: flex;align-items: center;justify-content: space-between;width: 600px">
              <el-input style="width: 145px;" v-model="initPage.steamLatestTradeCount" :placeholder="$t('Volume')"
                        size="small">
              </el-input>
              <el-input style="width: 120px;" v-model="initPage.maxProfitRate" placeholder="最高收益率(%)"
                        size="small">
              </el-input>
              <el-input style="width: 100px;" v-model="initPage.minPrice" placeholder="最低价格"
                        size="small"
                        suffix-icon="el-icon-money"
                        @keydown.native="triggerKeyDown($event)"></el-input>
              <el-input style="width: 100px;margin-right: 5px;" v-model="initPage.maxPrice"
                        size="small"
                        suffix-icon="el-icon-money" placeholder="最高价格"
                        @keydown.native="triggerKeyDown($event)"></el-input>
              <el-button
                type="primary"
                size="small"
                @click="queryItemList">
                {{ $t('Search') }}
              </el-button>
              <el-button type="warning" size="small" @click="resetInitPage" style="height: 32px;margin-left: 4px">
                {{ $t('Reset') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="loading">
        <el-skeleton :rows="6" animated/>
        <el-skeleton :rows="6" animated/>
        <el-skeleton :rows="6" animated/>
      </div>
      <el-table
        ref="table"
        :key="tableKey"
        v-show="!loading"
        size="mini"
        :data="staffList"
        style="width: 100%"
        column-key="id"
        :default-sort="{ prop: sortState.prop, order: sortState.order }"
        @sort-change="changeOrder"
      >
        <el-table-column
          key="img"
          prop="img"
          width="110"
        >
          <template slot-scope="props">
            <div :class="props.row.game === 'csgo' ? 'image-container':''">
              <div style="position: absolute;bottom: -2px;left: -1px">
                <el-tag v-if="checkIsGun(props.row.engName)" size="mini" effect="plain" type="info"
                        :style="formatterWear(props.row.engName.match(/\s*\([^)]*\)\s*$/)[0])">
                  {{
                    props.row.engName.match(/\s*\([^)]*\)\s*$/) ? formatterExterior(props.row.engName.match(/\s*\([^)]*\)\s*$/)[0]) : ''
                  }}
                </el-tag>
              </div>
              <img style="width: 90px" :src="props.row.iconUrl"/>

              <div @click="toggleFavorite(props.row.engName)"
                      class="favorite-button">
                <svg v-if="!isFavorite(props.row.engName)" t="1744634780221" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1559" width="16" height="16"><path d="M722.944 80.896c-79.872 0-155.648 31.744-210.944 88.064C456.704 112.64 380.928 80.896 301.056 80.896 138.24 80.896 5.12 212.992 5.12 374.784c0 96.256 48.128 164.864 82.944 214.016 104.448 148.48 363.52 330.752 374.784 338.944 14.336 10.24 31.744 15.36 49.152 15.36 17.408 0 34.816-5.12 49.152-15.36 11.264-8.192 270.336-190.464 374.784-338.944 34.816-50.176 82.944-117.76 82.944-214.016C1018.88 212.992 885.76 80.896 722.944 80.896zM896 561.152C796.672 702.464 543.744 880.64 532.48 888.832c-12.288 8.192-29.696 8.192-41.984 0-10.24-7.168-264.192-186.368-363.52-327.68C93.184 512 53.248 455.68 53.248 374.784c0-135.168 110.592-245.76 247.808-245.76 74.752 0 145.408 32.768 192.512 91.136l18.432 22.528 18.432-22.528c47.104-58.368 117.76-91.136 192.512-91.136 136.192 0 247.808 109.568 247.808 245.76C970.752 455.68 930.816 512 896 561.152zM857.088 246.784c-48.128-49.152-120.832-64.512-185.344-39.936-1.024 0-2.048 1.024-3.072 1.024-11.264 3.072-17.408 15.36-13.312 26.624 1.024 3.072 3.072 6.144 5.12 8.192 5.12 5.12 13.312 8.192 21.504 5.12 2.048 0 3.072-1.024 5.12-2.048 49.152-18.432 103.424-6.144 140.288 30.72 25.6 25.6 38.912 59.392 37.888 95.232 0 11.264 9.216 21.504 20.48 21.504 11.264 0 21.504-9.216 21.504-20.48C908.288 325.632 889.856 280.576 857.088 246.784z" p-id="1560"></path></svg>
                <svg v-else t="1744634859031" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1789" width="16" height="16"><path d="M21.333333 0v1024" fill="#2c2c2c" p-id="1790"></path><path d="M42.666667 0v1024" fill="#2c2c2c" p-id="1791"></path><path d="M64 0v1024" fill="#2c2c2c" p-id="1792"></path><path d="M85.333333 0v1024" fill="#2c2c2c" p-id="1793"></path><path d="M106.666667 0v1024" fill="#2c2c2c" p-id="1794"></path><path d="M128 0v1024" fill="#2c2c2c" p-id="1795"></path><path d="M149.333333 0v1024" fill="#2c2c2c" p-id="1796"></path><path d="M170.666667 0v1024" fill="#2c2c2c" p-id="1797"></path><path d="M192 0v1024" fill="#2c2c2c" p-id="1798"></path><path d="M213.333333 0v1024" fill="#2c2c2c" p-id="1799"></path><path d="M234.666667 0v1024" fill="#2c2c2c" p-id="1800"></path><path d="M256 0v1024" fill="#2c2c2c" p-id="1801"></path><path d="M277.333333 0v1024" fill="#2c2c2c" p-id="1802"></path><path d="M298.666667 0v1024" fill="#2c2c2c" p-id="1803"></path><path d="M320 0v1024" fill="#2c2c2c" p-id="1804"></path><path d="M341.333333 0v1024" fill="#2c2c2c" p-id="1805"></path><path d="M362.666667 0v1024" fill="#2c2c2c" p-id="1806"></path><path d="M384 0v1024" fill="#2c2c2c" p-id="1807"></path><path d="M405.333333 0v1024" fill="#2c2c2c" p-id="1808"></path><path d="M426.666667 0v1024" fill="#2c2c2c" p-id="1809"></path><path d="M448 0v1024" fill="#2c2c2c" p-id="1810"></path><path d="M469.333333 0v1024" fill="#2c2c2c" p-id="1811"></path><path d="M490.666667 0v1024" fill="#2c2c2c" p-id="1812"></path><path d="M512 0v1024" fill="#2c2c2c" p-id="1813"></path><path d="M533.333333 0v1024" fill="#2c2c2c" p-id="1814"></path><path d="M554.666667 0v1024" fill="#2c2c2c" p-id="1815"></path><path d="M576 0v1024" fill="#2c2c2c" p-id="1816"></path><path d="M597.333333 0v1024" fill="#2c2c2c" p-id="1817"></path><path d="M618.666667 0v1024" fill="#2c2c2c" p-id="1818"></path><path d="M640 0v1024" fill="#2c2c2c" p-id="1819"></path><path d="M661.333333 0v1024" fill="#2c2c2c" p-id="1820"></path><path d="M682.666667 0v1024" fill="#2c2c2c" p-id="1821"></path><path d="M704 0v1024" fill="#2c2c2c" p-id="1822"></path><path d="M725.333333 0v1024" fill="#2c2c2c" p-id="1823"></path><path d="M746.666667 0v1024" fill="#2c2c2c" p-id="1824"></path><path d="M768 0v1024" fill="#2c2c2c" p-id="1825"></path><path d="M789.333333 0v1024" fill="#2c2c2c" p-id="1826"></path><path d="M810.666667 0v1024" fill="#2c2c2c" p-id="1827"></path><path d="M832 0v1024" fill="#2c2c2c" p-id="1828"></path><path d="M853.333333 0v1024" fill="#2c2c2c" p-id="1829"></path><path d="M874.666667 0v1024" fill="#2c2c2c" p-id="1830"></path><path d="M896 0v1024" fill="#2c2c2c" p-id="1831"></path><path d="M917.333333 0v1024" fill="#2c2c2c" p-id="1832"></path><path d="M938.666667 0v1024" fill="#2c2c2c" p-id="1833"></path><path d="M960 0v1024" fill="#2c2c2c" p-id="1834"></path><path d="M981.333333 0v1024" fill="#2c2c2c" p-id="1835"></path><path d="M1002.666667 0v1024M0 21.333333h1024" fill="#2c2c2c" p-id="1836"></path><path d="M0 42.666667h1024" fill="#2c2c2c" p-id="1837"></path><path d="M0 64h1024" fill="#2c2c2c" p-id="1838"></path><path d="M0 85.333333h1024" fill="#2c2c2c" p-id="1839"></path><path d="M0 106.666667h1024" fill="#2c2c2c" p-id="1840"></path><path d="M0 128h1024" fill="#2c2c2c" p-id="1841"></path><path d="M0 149.333333h1024" fill="#2c2c2c" p-id="1842"></path><path d="M0 170.666667h1024" fill="#2c2c2c" p-id="1843"></path><path d="M0 192h1024" fill="#2c2c2c" p-id="1844"></path><path d="M0 213.333333h1024" fill="#2c2c2c" p-id="1845"></path><path d="M0 234.666667h1024" fill="#2c2c2c" p-id="1846"></path><path d="M0 256h1024" fill="#2c2c2c" p-id="1847"></path><path d="M0 277.333333h1024" fill="#2c2c2c" p-id="1848"></path><path d="M0 298.666667h1024" fill="#2c2c2c" p-id="1849"></path><path d="M0 320h1024" fill="#2c2c2c" p-id="1850"></path><path d="M0 341.333333h1024" fill="#2c2c2c" p-id="1851"></path><path d="M0 362.666667h1024" fill="#2c2c2c" p-id="1852"></path><path d="M0 384h1024" fill="#2c2c2c" p-id="1853"></path><path d="M0 405.333333h1024" fill="#2c2c2c" p-id="1854"></path><path d="M0 426.666667h1024" fill="#2c2c2c" p-id="1855"></path><path d="M0 448h1024" fill="#2c2c2c" p-id="1856"></path><path d="M0 469.333333h1024" fill="#2c2c2c" p-id="1857"></path><path d="M0 490.666667h1024" fill="#2c2c2c" p-id="1858"></path><path d="M0 512h1024" fill="#2c2c2c" p-id="1859"></path><path d="M0 533.333333h1024" fill="#2c2c2c" p-id="1860"></path><path d="M0 554.666667h1024" fill="#2c2c2c" p-id="1861"></path><path d="M0 576h1024" fill="#2c2c2c" p-id="1862"></path><path d="M0 597.333333h1024" fill="#2c2c2c" p-id="1863"></path><path d="M0 618.666667h1024" fill="#2c2c2c" p-id="1864"></path><path d="M0 640h1024" fill="#2c2c2c" p-id="1865"></path><path d="M0 661.333333h1024" fill="#2c2c2c" p-id="1866"></path><path d="M0 682.666667h1024" fill="#2c2c2c" p-id="1867"></path><path d="M0 704h1024" fill="#2c2c2c" p-id="1868"></path><path d="M0 725.333333h1024" fill="#2c2c2c" p-id="1869"></path><path d="M0 746.666667h1024" fill="#2c2c2c" p-id="1870"></path><path d="M0 768h1024" fill="#2c2c2c" p-id="1871"></path><path d="M0 789.333333h1024" fill="#2c2c2c" p-id="1872"></path><path d="M0 810.666667h1024" fill="#2c2c2c" p-id="1873"></path><path d="M0 832h1024" fill="#2c2c2c" p-id="1874"></path><path d="M0 853.333333h1024" fill="#2c2c2c" p-id="1875"></path><path d="M0 874.666667h1024" fill="#2c2c2c" p-id="1876"></path><path d="M0 896h1024" fill="#2c2c2c" p-id="1877"></path><path d="M0 917.333333h1024" fill="#2c2c2c" p-id="1878"></path><path d="M0 938.666667h1024" fill="#2c2c2c" p-id="1879"></path><path d="M0 960h1024" fill="#2c2c2c" p-id="1880"></path><path d="M0 981.333333h1024" fill="#2c2c2c" p-id="1881"></path><path d="M0 1002.666667h1024" fill="#2c2c2c" p-id="1882"></path><path d="M512 910l-62-56c-220-200-364-330-364-492C86 230 188 128 320 128c74 0 146 36 192 90C558 164 630 128 704 128c132 0 234 102 234 234 0 162-144 294-364 494z" fill="#2c2c2c" p-id="1883"></path></svg>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          key="skinsName"
          prop="staffName"
          min-width="175px"
          :label="$t('skinsName')">
          <template slot-scope="props">
            <div>
              <div
                class="clickBtn"
                style="font-size: 12px;font-weight: 600;display: flex">
                <div style="display: inline-block"
                     v-clipboard="$i18n.locale === 'zh' ?  props.row.cnName:props.row.engName">
                  <svg style="vertical-align: -15%;margin-right: 4px" t="1697807892694"
                       class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                       p-id="12027"
                       width="15" height="15">
                    <path
                      d="M888.19421 92.961228L866.427775 71.494058 793.886295 0H305.498188c-62.466274 0-113.101664 50.635389-113.101664 113.111639v16.010599h-12.459338c-62.466274 0-113.101664 50.635389-113.101664 113.101664v668.664459c0 62.466274 50.635389 113.111639 113.101664 113.111639h541.367728c62.466274 0 113.111639-50.645365 113.111639-113.111639v-16.010599h12.449363c62.465277 0 113.111639-50.635389 113.111639-113.101664V163.707127l-71.783345-70.745899zM770.074894 905.102599c0 31.233137-25.317695 56.549834-56.550832 56.549834H184.735378c-31.233137 0-56.560807-25.317695-56.560808-56.549834V250.124459c0-31.233137 25.32767-56.550832 56.560808-56.550832h7.661146V781.776098c0 62.466274 50.635389 113.101664 113.101664 113.101664h464.576706v10.224837z m125.561002-129.122238c0 31.234135-25.317695 56.550832-56.550832 56.550832H310.29638c-31.233137 0-56.560807-25.317695-56.560807-56.550832V121.012197c0-31.233137 25.32767-56.560807 56.560807-56.560808h393.930562v79.913338c0 17.656548 4.040058 34.365429 11.252308 49.248802 11.410918 23.532089 30.734365 42.525348 54.514843 53.488369 14.404551 6.653626 30.446074 10.364494 47.34349 10.364493h78.297315v518.51397z m0-580.850563H822.126797c-31.233137 0-56.549834-25.317695-56.549834-56.550832v-75.41441l1.306784 1.286833 128.753147 126.907688 3.830573 3.770721h-3.831571z"
                      fill="#272636" p-id="12028"></path>
                  </svg>
                </div>
                <div style="display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                     :style="props.row.engName.startsWith('Souvenir') ? 'color:rgb(230, 162, 60)':''"
                     @click="showDailyTradeInfo(props.row)">
                  {{
                    formatterShortenStaffName(props.row)
                  }}
                </div>
              </div>
              <div style="color: #8e9191;font-size: 12px;line-height: 14px;margin: 8px 0;display: flex">
                <div style="display: inline-block;margin-right: 12px;white-space: nowrap;height: 20px">
                  <el-tag v-if="props.row.rarityName" :style="formatterRarity(props.row.rarityName)" size="mini"
                          effect="plain" type="info">
                    {{ formatterLocalRarityName(props.row) }}
                  </el-tag>
                  <el-tag type="warning" size="mini" v-if="props.row.engName.indexOf('StatTrak™') !== -1"
                          effect="plain">
                    StatTrak™
                  </el-tag>
                  <el-tag type="warning" size="mini" v-if="props.row.engName.startsWith('Souvenir')" effect="plain">
                    {{ $i18n.locale === 'zh' ? '纪念品' : 'Souvenir' }}
                  </el-tag>
                </div>
              </div>
              <div style="display: flex;height: 23px" @click="queryWeaponCaseInfo(props.row)">
                <div v-if="props.row.weaponCase" class="hoverBtn"
                     style="margin-right: 6px;min-width: 13px;">
                  <svg style="vertical-align: -10%;" t="1697808953501" class="icon" viewBox="0 0 1024 1024"
                       version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="17252" width="14" height="14">
                    <path
                      d="M512.512 977.92c-25.6 0-50.176-6.144-71.168-17.408l-284.16-146.944c-50.688-27.136-81.92-79.36-81.92-135.68v-332.8c0-58.368 32.768-111.104 83.456-134.656l281.6-146.944c44.544-23.04 97.28-23.04 141.312 0l283.136 145.92c49.664 25.088 82.432 78.336 82.432 135.68V404.48c0 18.432-14.848 33.28-33.28 33.28S880.64 422.912 880.64 404.48V345.088c0-31.744-18.432-62.464-45.568-75.776L550.4 122.88c-24.576-12.8-55.296-12.8-79.36 0L187.904 270.336c-28.16 13.312-46.08 42.496-46.08 74.752v332.288c0 31.744 17.92 60.928 46.592 76.288L472.576 901.12c11.776 6.144 25.6 9.728 39.936 9.728 13.824 0 26.624-3.072 39.936-9.728l281.6-145.92c28.672-14.848 46.08-43.52 46.08-76.288v-58.88c0-18.432 14.848-33.28 33.28-33.28s33.28 14.848 33.28 33.28v58.88c0 57.344-31.232 109.056-81.92 135.68l-281.6 145.92c-23.552 11.776-46.592 17.408-70.656 17.408z"
                      p-id="17253" fill="#8a8a8a"></path>
                    <path
                      d="M505.856 538.112c-5.12 0-10.752-1.024-15.36-3.584L111.104 336.896c-16.384-8.704-22.528-28.672-14.336-45.056 8.704-16.384 28.672-22.528 45.056-14.336l363.52 188.928 379.392-203.776c16.384-8.704 36.352-2.56 45.568 13.824 8.704 16.384 2.56 36.352-13.824 45.568l-394.752 212.48c-4.608 2.048-10.24 3.584-15.872 3.584z"
                      p-id="17254" fill="#8a8a8a"></path>
                    <path
                      d="M505.856 977.92c-18.432 0-33.28-14.848-33.28-33.28v-440.32c0-18.432 14.848-33.28 33.28-33.28s33.28 14.848 33.28 33.28v439.808c0.512 18.944-14.336 33.792-33.28 33.792z m-227.328-424.96c-4.608 0-9.728-1.024-14.336-3.072l-62.464-30.208c-16.896-8.192-23.552-28.16-15.36-44.544 8.192-16.896 28.16-23.552 44.544-15.36l62.464 30.208c16.896 8.192 23.552 28.16 15.36 44.544-5.632 11.776-17.92 18.432-30.208 18.432z m636.928 6.144c-18.432 0-33.28-14.848-33.28-33.28v-33.28c0-18.432 14.848-33.28 33.28-33.28s33.28 14.848 33.28 33.28v33.28c0.512 18.432-14.336 33.28-33.28 33.28z"
                      p-id="17255" fill="#8a8a8a"></path>
                  </svg>
                </div>
                <div style="font-size: 12px;color: #aaaaaa;display: inline-block;margin-right: 8px;"
                     :class="props.row.weaponCase == null ? '':'hoverBtn'">
                  {{ formatterLocalWeaponCaseName(props.row.weaponCase) }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="platform in platformColumns"
          :key="platform.key"
          v-if="initPage.platform.includes(platform.key)"
          :prop="platform.prop"
          :label="platform.label"
          width="89"
          align="center"
        >
        <template slot-scope="props">
          <div>
            <el-link
              @click.prevent="routerChanger(platform.getUrl(props.row))">
                <span
                  v-if="props.row[platform.prop]"
                  :class="{ highlight: props.row.chosenMinPrice == props.row[platform.prop] }"
                >
                  {{ formatterPrice(props.row[platform.prop]) }}
                </span>
              <span v-else class="no-data">{{ $t('noData') }}</span>
            </el-link>
          </div>
        </template>
        </el-table-column>
        <el-table-column
          key="最低价格"
          prop="chosenMinPrice"
          label="底价"
          width="90"
          align="center"
          sortable="custom"
        >
          <template slot-scope="props">
              <div style="background: rgb(244, 244, 245);">
                <span style="color: rgb(144, 147, 153);">
                  {{ formatterPrice(props.row.chosenMinPrice) }}
                </span>
              </div>
          </template>
        </el-table-column>
        <el-table-column
          key="profitColumn"
          prop="profit"
          label="收益"
          width="90"
          align="center"
          sortable="custom"
        >
          <template slot-scope="props">
            <div class="profit-cell">
              <!-- 利润金额 -->
              <div>
                <span :style="{
                  color: getProfitValue(props.row) > 0 ? '#67C23A' : '#F56C6C'
                }">
                  {{ formatterPrice(getProfitValue(props.row)) }}
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          key="profitRateColumn"
          prop="profitRate"
          label="收益率"
          width="80"
          align="center"
          sortable="custom"
        >
          <template slot-scope="props">
            <div class="profit-cell">
              <!-- 利润率百分比 -->
              <div>
                <span :style="{
                  color: getProfitRate(props.row) > 0 ? '#67C23A' : '#F56C6C'
                }">
                  {{ getProfitRateText(props.row) }}
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          key="priceCompare1"
          label="比价"
          width="190"
          align="center"
        >
          <template slot="header">
            <div style="text-align: center;">
              <el-select
                v-model="initPage.comparePlatform"
                size="mini"
                style="width: 115px; font-size: 11px;"
                @change="handleComparePlatformChange"
              >
                <el-option
                  v-for="platform in platformList"
                  :key="platform.key"
                  :label="platform.name"
                  :value="platform.key"
                ></el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="props">
            <div>
              <div v-if="['BUFF_BUYER_PRICE','ECO_BUYER_PRICE','CSGOBUY_BUYER_PRICE',
              'DMARKET_BUYER_PRICE','UU_BUYER_PRICE','BUYER_PRICE'
              ].indexOf(initPage.comparePlatform) != -1" style="align-items: center;height: 75px">
                <div v-for="item in sortedPrices(props.row)" :key="item.name" style="display: flex;">
                  <div style="min-width: 70px;display: flex;align-items: center">
                    <i v-if="item.iconClass" :class="item.iconClass" style="margin-right: 4px"></i>
                    <div v-if="item.imgSrc" class="bottom clearfix" style="text-align: center;opacity: 0.5;margin-right: 4px;line-height: 14px">
                      <img :src="item.imgSrc" style="width: 14px;margin-right: 2px">
                    </div>
                    {{ item.name }}
                  </div>
                  <div class="priceTag">
                    <span v-if="item.price">{{ formatterPrice(item.price) }}</span>
                    <span v-else style="color: #aaaaaa">{{ $t('noData') }}</span>
                  </div>
                  <el-tag size="mini" effect="plain" v-if="item.price" :type="item.price > props.row.chosenMinPrice ? 'success':'danger'">
                    {{ formatterPrice(item.price - props.row.chosenMinPrice) }}
                  </el-tag>
                </div>
              </div>
              <div v-else style="display: flex;align-items: center;height: 75px" >
                <div v-if="['STEAM_BUYER_PRICE','STEAM_SELLER_PRICE'].indexOf(initPage.comparePlatform) != -1">
                  <!-- 动态显示对应平台的图标/图片 -->
                  <div >
                    <div style="display: flex">
                      <div style="min-width: 60px">STEAM:</div>
                      <div
                        class="priceTag"
                        :style="props.row.steamSellerPrice ? '':'color:#aaaaaa'"
                        @click="routerChanger(`https://steamcommunity.com/market/listings/${formatterGameId(props.row.game)}/${props.row.engName}`)">
                        {{
                          props.row.steamSellerPrice == null ? $t('noData') : formatterPrice(props.row.steamSellerPrice)
                        }}
                      </div>
                    </div>
                    <div style="display: flex">
                      <div style="min-width: 60px">{{ $t('SellOrder') }}:</div>
                      <div
                        class="priceTag"
                        :style="props.row.steamSellerPrice ? '':'color:#aaaaaa'"
                        @click="routerChanger(`https://steamcommunity.com/market/listings/${formatterGameId(props.row.game)}/${props.row.engName}`)">
                        {{
                          props.row.steamSellerPrice == null ? $t('noData') : formatterSteamPrice(props.row.steamSellerPrice)
                        }}
                      </div>
                      <el-tag
                        size="mini"
                        effect="plain"
                        v-if="props.row.chosenMinPrice && props.row.steamSellerPrice"
                        :type="formatterTagType(props.row.chosenMinPrice / props.row.steamSellerPrice  * 1.15)"
                      >
                        {{ formatterPrice(props.row.chosenMinPrice / props.row.steamSellerPrice * 1.15) }}
                      </el-tag>
                    </div>
                    <div style="display: flex">
                      <div style="min-width: 60px">{{ $t('BuyOrder') }}:</div>
                      <div
                        class="priceTag"
                        @click="routerChanger(`https://steamcommunity.com/market/listings/${formatterGameId(props.row.game)}/${props.row.engName}`)">
                        {{
                          props.row.steamBuyerPrice == null ? $t('noData') : formatterSteamPrice(props.row.steamBuyerPrice)
                        }}
                      </div>
                      <el-tag size="mini"
                              effect="plain"
                              v-if="props.row.chosenMinPrice && props.row.steamBuyerPrice"
                              :type="formatterTagType(props.row.chosenMinPrice / props.row.steamBuyerPrice  * 1.15)"
                      >
                        {{ formatterPrice(props.row.chosenMinPrice / props.row.steamBuyerPrice * 1.15) }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div v-else style="display: flex;flex: 1">
                  <!-- 动态显示对应平台的图标/图片 -->
                  <div >
                    <!-- 字体图标 -->
                    <i
                      v-if="getPlatformIconInfo(initPage.comparePlatform).type === 'icon'"
                      :class="getPlatformIconInfo(initPage.comparePlatform).iconClass"
                      style="margin-top: 5px;margin-left: 16px; font-size: 14px;"
                    ></i>

                    <!-- 图片图标 -->
                    <img
                      v-else-if="getPlatformIconInfo(initPage.comparePlatform).type === 'img'"
                      :src="getPlatformIconInfo(initPage.comparePlatform).imgSrc"
                      style="margin-top: 5px;margin-left: 16px; width: 14px; height: 14px; object-fit: contain;"
                      alt=""
                    >
                    <!-- 默认图标 -->
                    <svg v-else style="margin-top: 5px;margin-left: 16px"
                         t="1766663173317" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6965"
                         width="14" height="14">
                      <path d="M512 0a512 512 0 1 0 512 512A512.256 512.256 0 0 0 512 0z m0 981.333333a469.333333 469.333333 0 1 1 469.333333-469.333333 469.546667 469.546667 0 0 1-469.333333 469.333333z" p-id="6966"></path>
                      <path d="M717.994667 533.333333l-196.608 160.554667 28.970666 31.445333L810.666667 512l-260.778667-213.333333-28.416 32.128 196.437333 159.872H213.333333v42.666666h504.661334z" p-id="6967"></path>
                    </svg>

                    {{ getPlatformIconInfo(initPage.comparePlatform).name }}
                  </div>
                  <div style="flex: 1">
                    <span v-if="props.row">
                      {{ formatterComparePrice(props.row) }}
                    </span>
                    <span v-else style="color: #aaaaaa; font-size: 10px;">无数据</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div style="padding-top: 20px;padding-bottom: 10px;text-align: center">
        <el-pagination
          @size-change="changeSize"
          @current-change="changePage"
          :current-page.sync="initPage.offset"
          :page-sizes="[10, 20, 50]"
          :page-size="initPage.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="initPage.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      @open="initActiveWeaponType"
      width="940px"
      center
      :visible.sync="weaponDialog"
      append-to-body>
      <div slot="title">
        <div>
          <div style="font-weight: 600;font-size: 18px;position: relative">
            {{ formatterLocalWeaponCaseName(activeWeaponCase) }}
            <div style="position: absolute;top: -2px;margin-left: 14px" size="small">
              <el-tag class="hoverBtn" @click="changeWeaponCaseType('普通')"
                      :type="activeWeaponCaseType == '普通' ? 'primary':'info'"
                      v-if="normalList.length != 0">{{ $t('Normal') }}
              </el-tag>
              <el-tag class="hoverBtn" @click="changeWeaponCaseType('暗金')"
                      :type="activeWeaponCaseType == '暗金' ? 'primary':'info'"
                      v-if="stList.length != 0">{{ $t('StatTrak™') }}
              </el-tag>
              <el-tag class="hoverBtn" @click="changeWeaponCaseType('纪念品')"
                      :type="activeWeaponCaseType == '纪念品' ? 'primary':'info'"
                      v-if="sovList.length != 0">{{ $t('Souvenir') }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <div v-for="item of shownList">
        <div v-if="item.rarityName !== '★'">
          <div class="weaponbox_rarity_title" style="text-align:center"
               :style="formatterBackground(item.rarityName)">{{ $t(item.rarityName) }}
          </div>
          <el-table
            :show-header="false"
            :data="item.staffs"
            style="width: 100%">
            <el-table-column
              prop="iconUrl"
              width="90px">
              <template slot-scope="scope">
                <img style="height:40px" :src="scope.row.iconUrl">
              </template>
            </el-table-column>
            <el-table-column
              prop="cnShortName"
              width="285px">
              <template slot-scope="props">
                {{ formatterLocalName(props.row) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="minPirce">
              <template slot-scope="scope">
                <div style="display:flex">
                  <div style="display:inline-block;margin-right:12px;min-width: 90px" v-for="staff in scope.row.staffs">
                    <div v-if="staff !== null && staff !== undefined">
                      <div style="text-align: center;font-size: 13px">
                        {{ formatterExterior(staff.exterior) }}
                      </div>
                      <div style="text-align: center">
                        {{ staff.minPrice == null || staff.minPrice == undefined ? '' : staff.minPrice.toFixed(2) }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <div style="display: flex;height: 49px;width: 100%">
                  <div style="width: 90px;padding: 0 10px">
                    <img src="../../assets/goldBall.png" style="height: 49px">
                  </div>

                  <div style="text-align: center;width: 100%">
                    {{ $t('An extremely rare special item') }}
                  </div>
                </div>
              </template>
              <div>
                <el-table
                  :show-header="false"
                  :data="item.staffs"
                  style="width: 100%">
                  <el-table-column
                    prop="iconUrl"
                    width="90px">
                    <template slot-scope="scope">
                      <img style="height:40px" :src="scope.row.iconUrl">
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="cnShortName"
                    width="285px">
                    <template slot-scope="props">
                      {{ formatterLocalName(props.row) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="minPirce">
                    <template slot-scope="scope">
                      <div style="display:flex">
                        <div style="display:inline-block;margin-right:12px;min-width: 90px"
                             v-for="staff in scope.row.staffs">
                          <div v-if="staff !== null && staff !== undefined">
                            <div style="text-align: center;font-size: 13px">
                              {{ formatterExterior(staff.exterior) }}
                            </div>
                            <div style="text-align: center">
                              {{
                                staff.minPrice == null || staff.minPrice == undefined ? '' : staff.minPrice.toFixed(2)
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {
  queryItemList,
  queryItemsFromAllPlatform,
  remoteSearchOptions,
  allWeaponCasePriceRange,
  saveFilterSearchForm,
  getFilterSearchForm,
  deleteFilterSearchForm, validAdmin
} from '../../api/api'
import clipboard from "../../directive/clipboard";
import i18n from "../../main";
import {cloneObj, formatterRarity, formatterWear} from "../../api/util";
const {currencyIconOptions} = require("../../api/util");
const {rarityOptions, rarityDic} = require("../../api/util");
const {wearTypeOptions} = require("../../api/util");
import JSEncrypt from 'jsencrypt';
const CryptoJS = require('crypto-js');
const RSA_PRIVATE_KEY = `-----BEGIN RSA PRIVATE KEY-----
MIICWgIBAAKBgE8LD5uG+UnnXbtyl77tBlzrsQyM2XZY5aajsch+OvYCojSO6Oks
f6vbP/VYnLH6SLFeSXIvfSZWBlZdYgpQ8rJmhZVJy2T0ay40TSYHqiee2XOHRC3G
llDgZvS9aCaRdDhuaW4cN+yg/VNtM3VibLVW1StcPR+h9G8kjTobUNYVAgMBAAEC
gYA1eqFbtA20f/K+IYEj75BvjBPlDuMPHIR8o6JkqWtRCWUftFVHdhEHgLccU5Dp
JhLK1qVQuWquZmOxSUtM+YnKg4JUeG4XVfu0f/p18ZLa0RoxVG1+vCAauCLB/rnk
rU6y/NllN10W6/fJcW7UwFmJsyi9KP9FN2wSUzy7ziBrfQJBAJgLDPVws2386u75
HnIr/hAI286h9pLGLHRi/qVBW6pPFNW1EKK/d9dwNXurATxqpZJvfKIceFq9QdZm
eFg388MCQQCFFm1RJZLK7THdoEBBfY9EzhiWJ9u1B3+3Rnb7yYsg3CZIpF9RTwkx
dR1KMbH4KlBPaFGzgMBF7qKbsyqpFilHAkBzVjavXZ4PeoPxYnNRIsQo/79WoZB9
yO1iINKRI+JYcIMalq8W9m3/tPQtawyV+0S8r+v4weYe12DBNpxmN5OnAkAVQv33
5s7KyJYc2Asr60lGLr7Szk9VXntS5lj/5LTrbQBYvpnTvZK0agdh4QqToP7vkLTs
vnb5NSSZR0hbdwTlAkBbwNhI6Juz9qYLbGNg4scBIu5LAb2vlG/Alozvn8q7kxLz
3wbFWShJA9D6BEiJmjSrQ1QD+PWrhljzj8yrN4Te
-----END RSA PRIVATE KEY-----`;

export default {
  name: 'homePageTable',
  props: ['game', 'weaponCasesIndex', 'weaponCasesOptions','categoryOptions'],
  directives: {clipboard},
  data() {
    return {
      favorites: [],
      width: 79,
      activePlatform: '',
      staffList: [],
      loading: false,
      rarityOptions: rarityOptions,
      contrastOption: 'SteamMarketPriceAfterFee',
      contrastOptions: [
        {value: 'SteamMarketPrice', label: 'Steam市场价'},
        {value: 'SteamMarketPriceAfterFee', label: 'Steam到手余额'},
        {value: 'PurchaseOrderData', label: '求购价格降序'}
      ],
      orderOptions: [],
      wearTypeOptions: wearTypeOptions,
      csgoPlatformOptions: [
        {optionKey: 'BUFF', optionValue: 'BUFF'},
        {optionKey: 'DMarket', optionValue: 'DMarket'},
        {optionKey: 'C5Game', optionValue: 'C5Game'},
        {optionKey: 'SkinPort', optionValue: 'SkinPort'},
        {optionKey: 'IGXE', optionValue: 'IGXE'},
        {optionKey: '悠悠有品', optionValue: 'UUPIN'},
        {optionKey: 'Eco', optionValue: 'Eco'},
        {optionKey: 'BitSkins', optionValue: 'BitSkins'},
        {optionKey: 'LisSkins', optionValue: 'LisSkins'},
        {optionKey: 'CsMoney', optionValue: 'CsMoney'},
        {optionKey: 'SkinBaron', optionValue: 'SkinBaron'},
        {optionKey: 'CsgoBuy', optionValue: 'CsgoBuy'},
        {optionKey: 'V5Item', optionValue: 'V5Item'},
        {optionKey: 'Csfloat', optionValue: 'Csfloat'},
        {optionKey: 'Tradeit', optionValue: 'Tradeit'},
        {optionKey: 'HaloSkins', optionValue: 'HaloSkins'},
        {optionKey: 'Waxpeer', optionValue: 'Waxpeer'}
      ],
      dota2PlatformOptions: [
        {optionKey: 'BUFF', optionValue: 'BUFF'},
        {optionKey: 'DMarket', optionValue: 'DMarket'},
        {optionKey: 'C5Game', optionValue: 'C5Game'},
        {optionKey: 'SkinPort', optionValue: 'SkinPort'},
        {optionKey: 'IGXE', optionValue: 'IGXE'},
        {optionKey: 'BitSkins', optionValue: 'BitSkins'},
        {optionKey: 'LisSkins', optionValue: 'LisSkins'},
        {optionKey: 'Eco', optionValue: 'Eco'},
        {optionKey: 'Waxpeer', optionValue: 'Waxpeer'},
        {optionKey: 'CsgoBuy', optionValue: 'CsgoBuy'}
      ],
      rustPlatformOptions: [
        {optionKey: 'DMarket', optionValue: 'DMarket'},
        {optionKey: 'C5Game', optionValue: 'C5Game'},
        {optionKey: 'SkinPort', optionValue: 'SkinPort'},
        {optionKey: 'IGXE', optionValue: 'IGXE'},
        {optionKey: 'Waxpeer', optionValue: 'Waxpeer'},
        {optionKey: 'CsgoBuy', optionValue: 'CsgoBuy'},
        {optionKey: 'RustSkins', optionValue: 'RustSkins'}
      ],
      tableKey: 0,  // 用于控制表格重渲染的 key
      sortState: {
        prop: 'profitRate', // 当前排序的字段
        order: 'descending' // 当前排序方向：ascending/descending
      },
      operation:'-',
      // 平台配置列表（精简版，只保留实际用到的）
      platformList: [
        { key: 'BUFF_BUYER_PRICE',value: 'buffBuyerPrice',  name: 'BUFF求购价' },
        { key: 'STEAM_BUYER_PRICE', value: 'steamBuyerPrice', name: 'Steam' },
        { key: 'BUFF_PRICE',value: 'buffPrice',  name: 'BUFF' },
        { key: 'UU_PRICE', value: 'uuPrice', name: '悠悠有品' },
        { key: 'CS_MONEY_PRICE',value: 'csMoneyPrice',  name: 'CsMoney'},
        { key: 'CSFLOAT_PRICE',value: 'csfloatPrice',  name: 'CsFloat' },
        { key: 'C5_PRICE', value: 'c5Price', name: 'C5Game'},
        { key: 'IGXE_PRICE',value: 'igxePrice',  name: 'IGXE' },
        { key: 'V5ITEM_PRICE',value: 'v5ItemPrice',  name: 'V5Item' },
        { key: 'ECO_PRICE',value: 'ecoPrice',  name: 'ECO' },
        { key: 'SKINPORT_PRICE',value: 'skinPortPrice',  name: 'SkinPort' },
        { key: 'DMARKET_PRICE', value: 'dmarketPrice', name: 'DMarket' },
        { key: 'TRADEIT_PRICE',value: 'tradeitPrice',  name: 'Tradeit'},
        // { key: 'BITSKINS_PRICE', value: 'bitSkinsPrice', name: 'BitSkins' },
        { key: 'LISSKINS_PRICE', value: 'lisSkinsPrice', name: 'LisSkins' },
        { key: 'CSGOBUY_BUYER_PRICE', value: 'csgoBuyBuyerPrice', name: '低于CsgoBuy求购价' }
        // { key: 'STEAM_SELLER_PRICE',value: 'steamSellerPrice',  name: 'Steam售价' },
      ],
      initPage: {
        comparePlatform: 'BUFF_BUYER_PRICE',
        wearType: '',
        quality: '',   // 0 普通 1纪念品 2暗金
        rarityName: '',
        name: '',
        minPrice: '100',
        minProfitRate: '',
        maxProfitRate: '',
        maxPrice: '',
        total: 0,
        limit: 10,
        steamLatestTradeCount: 0,
        offset: 1,
        staffGame: 'csgo',
        platform: [],
        category:''
      },
      weaponDialog: false,
      dailyTradeTable: [],
      dailyTradeTotalCount: 0,
      dailyTradePageInfo: {
        limit: 10,
        offset: 1
      },
      activeWeaponCase: '',
      activeWeaponCaseType: '普通',
      normalList: [],
      stList: [],
      sovList: [],
      selectedCurrency: localStorage.getItem('selectedCurrency') || 'CNY',
      createFilterVisible: false,
      filterPresetsName: '',  // 预设名
      filterLoading: false,
      passedCheck:false
    }
  },
  computed: {
    shownList() {
      if (this.activeWeaponCaseType === '普通') {
        return this.normalList
      } else if (this.activeWeaponCaseType === '纪念品') {
        return this.sovList
      } else {
        return this.stList
      }
    },
    platformColumns() {
      return [
        { key: 'BUFF', prop: 'buffPrice', label: 'BUFF', getUrl: row => `https://buff.163.com/goods/${row.buffId}?utm_source=hangKnife.com` },
        { key: 'C5Game', prop: 'c5Price', label: 'C5Game', getUrl: row => `https://www.c5game.com/${row.game}/${row.c5Id}/${row.engName}/sell?utm_source=hangKnife.com` },
        { key: 'IGXE', prop: 'igxePrice', label: 'IGXE', getUrl: row => `https://www.igxe.cn/product/${this.formatterGameId(row.game)}/${row.igxeId}?utm_source=hangKnife.com` },
        { key: 'UUPIN', prop: 'uuPrice', label: 'UUPin', getUrl: row => `https://www.youpin898.com/market/goods-list?listType=10&templateId=${row.uupinId}&gameId=730` },
        { key: 'V5Item', prop: 'v5ItemPrice', label: 'V5Item', getUrl: row => `https://v5item.com/goods/${row.engName}?tabbar=0&utm_source=hangKnife.com` },
        { key: 'Eco', prop: 'ecoPrice', label: 'ECO', getUrl: row => `https://www.ecosteam.cn/goods/730-${row.ecoId}-1-laypagesale-0-1.html?utm_source=hangKnife.com` },
        { key: 'SkinPort', prop: 'skinPortPrice', label: 'SkinPort', getUrl: row => this.formatterSkinPortUrl(row) },
        { key: 'CsMoney', prop: 'csMoneyPrice', label: 'CsMoney', getUrl: row => `https://cs.money/zh/market/buy?utm_source=mediabuy&utm_medium=hangknife&utm_campaign=market&utm_content=link&sort=price&order=asc&search=`+row.engName },
        { key: 'Tradeit', prop: 'tradeitPrice', label: 'Tradeit', getUrl: row => row.tradeitLink+'&aff=hangKnife' },
        { key: 'CsgoBuy', prop: 'csgoBuyPrice', label: 'CsgoBuy', getUrl: row => this.formatterCsgoBuyUrl(row) },
        { key: 'BitSkins', prop: 'bitskinsPrice', label: 'BitSkins', getUrl: row => this.formatSkinNameToURL(row.game == 'csgo' ? 'cs2':'dota2',row.engName) },
        { key: 'LisSkins', prop: 'lisSkinsPrice', label: 'LisSkins', getUrl: row => this.formatLisSkins(row.lisSkinsUrl) },
        { key: 'SkinBaron', prop: 'skinbaronPrice', label: 'SkinBaron', getUrl: row => row.skinbaronMarketPage ? row.skinbaronMarketPage+'&affiliateId=822' : 'https://skinbaron.de/affiliate/822.html' },
        { key: 'HaloSkins', prop: 'haloPrice', label: 'Halo', getUrl: row => row.haloMarketPage },
        { key: 'Waxpeer', prop: 'waxpeerPrice', label: 'Waxpeer', getUrl: row => `https://www.waxpeer.com/r/hangknife?game=csgo&sort=ASC&order=price&all=0&search=${row.engName}&exact=1` },
        { key: 'RustSkins', prop: 'rustSkinsPrice', label: 'RustSkins', getUrl: () => `https://rustskins.com/r/hangknife` },
        { key: 'Csfloat', prop: 'csfloatPrice', label: 'Csfloat', getUrl: row => `https://csfloat.com/search?sort_by=lowest_price&market_hash_name=`+row.engName },
        { key: 'DMarket', prop: 'dmarketPrice', label: 'DMarket', getUrl: row => this.formatterDmarketUrl(row) }
      ]
    }
  },
  methods: {
    getProfitValue(row) {

      if (isNaN(row.chosenMinPrice)) return '0.00';

      // 1. 加强空值校验：row、对比平台标识都要校验
      if (!row || !this.initPage.comparePlatform) return '0.00';

      // 2. 筛选平台时增加容错：避免find返回undefined导致后续报错
      const targetPlatform = this.platformList.find(v => v.key === this.initPage.comparePlatform);
      if (!targetPlatform) return '0.00';

      const value = targetPlatform.value;
      // 3. 校验选中平台的价格是否存在且为数字
      const platformPrice = Number(row[value]);
      if (isNaN(platformPrice)) return '0.00';

      // 4. 计算差值并保留2位小数（返回字符串，避免toFixed后变成数字如1.20变成1.2）
      const profit = (platformPrice - row.chosenMinPrice).toFixed(2);
      return profit;
    },

    // 2. 计算利润率百分比（利润/购买价 * 100%）
    getProfitRate(row) {
      if (!row || !row.chosenMinPrice) return 0;
      const profit = this.getProfitValue(row);
      if (profit === 0 || row.chosenMinPrice === 0) return 0;
      return ((profit / row.chosenMinPrice) * 100).toFixed(1);
    },

    // 3. 格式化利润率显示文本
    getProfitRateText(row) {
      const rate = this.getProfitRate(row);
      if (rate > 0) return '+' + rate + '%';
      return rate + '%';
    },

    handleComparePlatformChange(){
      this.queryItemList()
      this.$nextTick(_=>{
        this.tableKey += 1;
      })
    },

    getUrlParameter() {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      if(urlParams.has('pluginCode')) {
        // 校验oauthCode
        let pluginCode = urlParams.get('pluginCode')
        validAdmin({authCode:pluginCode}).then(json=>{
          if (json.data.flag == 'T'){
            this.passedCheck = true
            this.platformList = [
              ...this.platformList,
              { key: 'ECO_BUYER_PRICE', value: 'ecoBuyerPrice', name: '低于ECO求购' },
              { key: 'DMARKET_BUYER_PRICE', value: 'dmarketBuyerPrice', name: '低于DMarket求购' },
              { key: 'UU_BUYER_PRICE', value: 'uuBuyerPrice', name: '低于UU求购' },
              { key: 'BUYER_PRICE', value: 'buyerPrice', name: '低于求购中位值' }
            ]
            this.tableKey +=1;
          }
        })
      }
    },
    sortedPrices(row) {
      const priceData = [
        {
          name: 'BUFF',
          price: row.buffBuyerPrice,
          iconClass: 'icon-buff iconfont icon-guanfangmeiti mr-5 text-26'
        },
        {
          name: '悠悠有品',
          price: row.uuBuyerPrice,
          iconClass: 'icon-youpin iconfont icon-guanfangmeiti mr-5 text-26'
        },
        {
          name: 'DMarket',
          price: row.dmarketBuyerPrice,
          iconClass: 'icon-dmarket iconfont icon-guanfangmeiti mr-5 text-26'
        },
        {
          name: 'ECO',
          price: row.ecoBuyerPrice,
          imgSrc: '../../../static/imgs/eco.png'
        },
        {
          name: 'IGXE',
          price: row.igxeBuyerPrice,
          imgSrc: '../../../static/imgs/igxe.png'
        },
        {
          name: 'CsgoBuy',
          price: row.csgoBuyBuyerPrice,
          imgSrc: '../../../static/imgs/csgobuy.png'
        },
        {
          name: 'CsFloat',
          price: row.csfloatBuyerPrice,
          imgSrc: '../../../static/imgs/csfloat.png'
        },
        {
          name: 'C5Game',
          price: row.c5BuyerPrice,
          iconClass: 'iconfont text-color-lightgray mr-5 icon-c5'
        }
      ];
      return priceData.filter(item => item.price).sort((a, b) => b.price - a.price).slice(0, 3);
    },
    formatterGameId(game) {
      switch (game) {
        case "csgo":
          return 730;
        case "dota2":
          return 570;
        case "rust":
          return 252490;
        case "tf2":
          return 440;
        default:
          return 730;
      }
    },
    switchPlatformOptions() {
      switch (this.game) {
        case "dota2":
          return this.dota2PlatformOptions
        case "csgo":
          return this.csgoPlatformOptions
        case "rust":
          return this.rustPlatformOptions
        default:
          return []
      }
    },
    switchOrderOptions() {
      switch (this.game) {
        case "csgo":
          this.orderOptions = [
            {value: '(chosenMinPrice / buffBuyerPrice),ASC', label: '低于Buff求购'},
            {value: '(chosenMinPrice / uuPrice),ASC', label: '低于UU在售'},
            {value: '(chosenMinPrice / steamSellerPrice),ASC', label: '最优Steam寄售'},
            {value: '(chosenMinPrice / steamBuyerPrice),ASC', label: '最优Steam求购'},
            {value: '(chosenMinPrice / steamSafeBuyerPrice),ASC', label: '稳定Steam求购'},
            {value: 'chosenMinPrice,ASC', label: '低价优先'},
            {value: 'chosenMinPrice,DESC', label: '高价优先'}
          ]
          break;
        case "dota2":
          this.orderOptions = [
            {value: '(chosenMinPrice / steamSellerPrice),ASC', label: '最优Steam寄售'},
            {value: '(chosenMinPrice / steamBuyerPrice),ASC', label: '最优Steam求购'},
            {value: '(chosenMinPrice / steamSafeBuyerPrice),ASC', label: '稳定Steam求购'},
            // {value: '(chosenMinPrice / steamSellerPrice),DESC', label: '第三方寄售价降序'},
            {value: 'chosenMinPrice,ASC', label: '低价优先'},
            {value: 'chosenMinPrice,DESC', label: '高价优先'},
            // {value: '(chosenMinPrice / buffBuyerPrice),ASC', label: '低于Buff求购'}
          ]
          break;
        case "rust":
          this.orderOptions = [
            {value: '(chosenMinPrice / steamSellerPrice),ASC', label: '最优Steam寄售'},
            {value: '(chosenMinPrice / steamBuyerPrice),ASC', label: '最优Steam求购'},
            {value: '(chosenMinPrice / steamSafeBuyerPrice),ASC', label: '稳定Steam求购'},
            // {value: '(chosenMinPrice / steamSellerPrice),DESC', label: '第三方寄售价降序'},
            {value: 'chosenMinPrice,ASC', label: '低价优先'},
            {value: 'chosenMinPrice,DESC', label: '高价优先'}
          ]
          break;
        default:
          return []
      }
    },
    timeAgo(inputTime) {
      const inputDate = new Date(inputTime);
      const now = new Date();
      const diffInSeconds = Math.floor((now - inputDate) / 1000);
      let preStr = ""
      if (localStorage.getItem("selectedLanguage") == 'zh') {
        preStr = "同步于 "
      } else {
        preStr = "Update "
      }
      if (diffInSeconds < 60) {
        return `${preStr}${diffInSeconds}${localStorage.getItem("selectedLanguage") == 'zh' ? ' 秒前' : "s ago"}`;
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${preStr}${minutes}${localStorage.getItem("selectedLanguage") == 'zh' ? ' 分钟前' : "m ago"}`;
      } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `${preStr}${hours}${localStorage.getItem("selectedLanguage") == 'zh' ? ' 小时前' : "h ago"}`;
      } else {
        const days = Math.floor(diffInSeconds / 86400);
        return `${preStr}${days}${localStorage.getItem("selectedLanguage") == 'zh' ? ' 天前' : "d ago"}`;
      }
    },
    formatterLocalWeaponCaseName(val) {
      return val
    },
    formatterLocalRarityName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.rarityName
      } else {
        return rarityDic[item.rarityName]
      }
    },
    formatterLocalName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.cnShortName
      } else {
        return item.shortName
      }
    },
    hoverPlatform(val) {
      this.activePlatform = val
    },
    changeShownPrice(val) {
      switch (val) {
        case "steamLatestTradeCount,DESC":
        case "(chosenMinPrice / steamSellerPrice),ASC":
        case "(chosenMinPrice / steamBuyerPrice),ASC":
        case "(chosenMinPrice / steamSafeBuyerPrice),ASC":
        case "(chosenMinPrice / steamLatestTradePrice),ASC":
        case "(chosenMinPrice / steamSellerPrice),DESC":
          this.contrastOption = 'SteamMarketPriceAfterFee'
          this.queryItemList()
          break;
        case "(chosenMinPrice / buffBuyerPrice),ASC":
        case "(chosenMinPrice / uuBuyerPrice),ASC":
        case "(chosenMinPrice / dmarketBuyerPrice),ASC":
          this.contrastOption = 'PurchaseOrderData'
          this.queryItemList()
          break;
        default:
          this.contrastOption = 'PurchaseOrderData'
          this.queryItemList()
      }
    },
    formatterLocalOption(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.optionValue
      } else {
        return item.optionKey
      }
    },
    changeWeaponCaseType(val) {
      this.activeWeaponCaseType = val
    },
    formatterBackground(val) {
      switch (val) {
        case '隐秘':
          return 'background: rgb(235, 75, 75);'
        case '保密':
          return 'background: rgb(211, 44, 230);'
        case '受限':
          return 'background: rgb(136, 71, 255);'
        case '军规级':
          return 'background: rgb(75, 105, 255);'
        case '工业级':
          return 'background: rgb(94, 152, 217);'
        case '消费级':
          return 'background: rgb(176, 195, 217);'
        case '非凡':
          return 'background: rgb(235, 75, 75)'
        case '奇异':
          return 'background: rgb(211, 44, 230)'
        case '卓越':
          return 'background: rgb(136, 71, 255)'
        case '高级':
          return 'background: rgb(75, 105, 255)'
        default:
          return ''
      }
    },
    checkIsGun(engName) {
      if (engName.indexOf('Battle-Scarred') !== -1) {
        return true
      } else if (engName.indexOf('Well-Worn') !== -1) {
        return true
      } else if (engName.indexOf('Field-Tested') !== -1) {
        return true
      } else if (engName.indexOf('Minimal Wear') !== -1) {
        return true
      } else if (engName.indexOf('Factory New') !== -1) {
        return true
      } else {
        return false
      }
    },
    formatterExterior(val) {
      if (val == null) {
        return
      }
      val = val.trim()
      val = val.replace('(', '')
      val = val.replace(')', '')
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        switch (val) {
          case 'Battle-Scarred':
            return '战痕累累'
          case 'Well-Worn':
            return '破损不堪'
          case 'Field-Tested':
            return '久经沙场'
          case 'Minimal Wear':
            return '略有磨损'
          case 'Factory New':
            return '崭新出厂'
        }
      } else {
        return val
      }
    },
    queryWeaponCaseInfo(val) {
      if (val.staffGame === 'dota2') {
        return
      }
      if (val.weaponCase !== null && val.weaponCase !== undefined) {
        this.activeWeaponCase = val.weaponCase
        allWeaponCasePriceRange({weaponCase: val.weaponCase}).then(json => {
          this.normalList = json.data.normal
          this.stList = json.data.st
          this.sovList = json.data.sov
          this.weaponDialog = true
        })
      }
    },
    formatterTagType(val) {
      if (val <= 0.7) {
        return 'success'
      } else if (val <= 0.8) {
        return 'primary'
      } else if (val <= 0.9) {
        return 'warning'
      } else {
        return 'danger'
      }
    },
    getPlatformIconInfo(platformKey) {
      // 建立完整的平台key和图标信息映射
      const iconMap = {
        // 字体图标类
        'BUFF_PRICE': {
          name: 'BUFF',
          type: 'icon',
          iconClass: 'icon-buff iconfont icon-guanfangmeiti mr-5 text-26'
        },
        'BUFF_BUYER_PRICE': {
          name: 'BUFF',
          type: 'icon',
          iconClass: 'icon-buff iconfont icon-guanfangmeiti mr-5 text-26'
        },
        'UU_PRICE': {
          name: '悠悠有品',
          type: 'icon',
          iconClass: 'icon-youpin iconfont icon-guanfangmeiti mr-5 text-26'
        },
        'C5_PRICE': {
          name: 'C5Game',
          type: 'icon',
          iconClass: 'iconfont text-color-lightgray mr-5 icon-c5'
        },
        // 图片图标类
        'ECO_PRICE': {
          name: 'ECO',
          type: 'img',
          imgSrc: '../../../static/imgs/eco.png'
        },
        'IGXE_PRICE': {
          name: 'IGXE',
          type: 'img',
          imgSrc: '../../../static/imgs/igxe.png'
        },
        // 补充其他平台（根据你的实际需求添加）
        'CSGOBUY_PRICE': { // 请替换为实际的platformKey
          type: 'img',
          imgSrc: '../../../static/imgs/csgobuy.png',
          name: 'CSGOBUY',
        },
        'CS_MONEY_PRICE': { // 请替换为实际的platformKey
          name: 'CSMoney',
          type: 'img',
          imgSrc: '../../../static/imgs/csmoney.png'
        },
        'CSFLOAT_PRICE': { // 请替换为实际的platformKey
          type: 'img',
          name: 'CSFloat',
          imgSrc: '../../../static/imgs/csfloat.png'
        },
        'DMARKET_PRICE': { // 请替换为实际的platformKey
          name: 'DMarket',
          type: 'icon',
          iconClass: 'icon-dmarket iconfont icon-guanfangmeiti mr-5 text-26'
        },
        // 其他平台默认显示默认图标
        'SKINPORT_PRICE': { type: 'default', name: 'SkinPort' },
        'TRADEIT_PRICE': { type: 'default', name: 'TradeIT' },
        'BITSKINS_PRICE': { type: 'default', name: 'BitSkins' },
        'STEAM_SELLER_PRICE': {
          name: 'Steam',
          type: 'icon',
          iconClass: 'icon-steam iconfont icon-guanfangmeiti mr-5 text-26'
        },
        'STEAM_BUYER_PRICE': {
          name: 'Steam',
          type: 'icon',
          iconClass: 'icon-steam iconfont icon-guanfangmeiti mr-5 text-26'
        },
        'V5ITEM_PRICE': { type: 'default', name: 'V5Item' }
      };

      // 返回对应的图标信息，没有则返回默认类型
      return iconMap[platformKey] || { type: 'default' };
    },
    formatterComparePrice(row){
      const targetPlatform = this.platformList.find(v => v.key === this.initPage.comparePlatform);
      if (!targetPlatform) return '0.00';
      const value = targetPlatform.value;
      return this.formatterPrice(row[value])
    },
    formatterPrice(val) {
      // 获取货币单位
      let currency = this.$store.getters.getCurrency
      let currencyOptions = this.$store.getters.getCurrencyOptions
      if (currency !== 'CNY') {
        let rate = parseFloat(currencyOptions[currency])
        let currencyIcon = currencyIconOptions[currency]
        if (currency === 'RUB' || currency === 'TRY') {
          return val == null ? null : (val / rate).toFixed(2) + " " + currencyIcon
        } else {
          return val == null ? null : currencyIcon + " " + (val / rate).toFixed(2)
        }
      } else {
        return val == null ? null : (Number(val) >= 100000 ? Number(val).toFixed(1) : Number(val).toFixed(2))
      }
    },
    formatterSteamPrice(inputVal){
      let fee = inputVal * 0.13 >= 0.14 ? inputVal * 0.13 : 0.14
      let val = inputVal - fee;
      // 获取货币单位
      let currency = this.$store.getters.getCurrency
      let currencyOptions = this.$store.getters.getCurrencyOptions
      if (currency !== 'CNY') {
        let rate = parseFloat(currencyOptions[currency])
        let currencyIcon = currencyIconOptions[currency]
        if (currency === 'RUB' || currency === 'TRY') {
          return val == null ? null : (val / rate).toFixed(2) + " " + currencyIcon
        } else {
          return val == null ? null : currencyIcon + " " + (val / rate).toFixed(2)
        }
      } else {
        return val == null ? null : (Number(val) >= 100000 ? Number(val).toFixed(1) : Number(val).toFixed(2))
      }
    },
    toggleFavorite(engName) {
      if (this.favorites.length >= 100 && !this.isFavorite(engName)) {
        this.$message({
          message: '最多只能收藏 100 条记录!',
          type: 'warning'
        });
        return;
      }
      const index = this.favorites.indexOf(engName);
      if (index === -1) {
        this.favorites.push(engName);
        this.$message({
          message: '收藏成功!',
          type: 'success'
        });
      } else {
        this.favorites.splice(index, 1);
        this.$message({
          message: '取消收藏成功!',
          type: 'success'
        });
      }
      localStorage.setItem('favorites', JSON.stringify(this.favorites));
    },
    // 检查项目是否已收藏
    isFavorite(engName) {
      return this.favorites.includes(engName);
    },
    formatSkinNameToURL(game, skinName) {
      const encodedSkinName = encodeURIComponent(skinName);
      const searchQuery = `"where":{"skin_name":"${encodedSkinName}"}`;
      const url = `https://bitskins.com/market/${game}?ref_alias=babaiwan&search={"order":[{"field":"price","order":"ASC"}],${searchQuery}}`;
      return url;
    },
    formatLisSkins(url){
      return url + "?rf=1866614";
    },
    showDailyTradeInfo(val) {
      let routeUrl = this.$router.resolve({
        path: "/itemPage",
        query: {marketHashName: val.engName}
      });
      window.open(routeUrl.href, '_blank');
    },
    fillDefaultSearchForm() {
      this.sortState.prop = 'profit';
      this.sortState.order = 'descending';
      this.initPage = {
        "filterName": "武器箱",
        "comparePlatform":"BUFF_BUYER_PRICE",
        "name": "武器箱",
        "limit": 50,
        "offset": 1,
        "game": "csgo",
        "platform": ["BUFF","DMarket", "C5Game", "SkinPort", "UUPIN", "CsMoney", "Eco", "BitSkins"]
      }
      this.buildOrderBy()
      this.queryItemList()
    },
    myfavors(){
      this.sortState.prop = 'profit';
      this.sortState.order = 'descending';
      this.initPage = {
        "engNames":this.favorites,
        "filterName": "我的收藏",
        "comparePlatform":"BUFF_BUYER_PRICE",
        "name": "",
        "limit": 100,
        "steamLatestTradeCount": '',
        "offset": 1,
        "game": "csgo",
        "platform": ["BUFF", "DMarket", "C5Game", "SkinPort", "UUPIN","Eco", "CsMoney","SkinBaron"]
      }
      this.buildOrderBy()
      this.queryItemList()
    },
    fillAgentSearchForm(){
      this.sortState.prop = 'profit';
      this.sortState.order = 'descending';
      this.initPage = {
        "filterName": "胶囊",
        "comparePlatform":"BUFF_BUYER_PRICE",
        "name": "",
        "weaponCase": ["Agents"],
        "limit": 50,
        "offset": 1,
        "game": "csgo",
        "platform": ["BUFF", "DMarket", "C5Game", "SkinPort", "UUPIN", "CsMoney", "Eco", "SkinBaron"]
      }
      this.buildOrderBy()
      this.queryItemList()
    },
    fillDefaultSearchForm2() {
      this.sortState.prop = 'profit';
      this.sortState.order = 'descending';
      this.initPage = {
        "filterName": "胶囊",
        "comparePlatform":"BUFF_BUYER_PRICE",
        "name": "Sticker Capsule",
        "limit": 50,
        "offset": 1,
        "game": "csgo",
        "platform": ["BUFF", "DMarket", "C5Game", "SkinPort", "IGXE", "UUPIN", "CsMoney", "Eco", "SkinBaron"]
      }
      this.buildOrderBy()
      this.queryItemList()
    },
    fillSearchForm(val) {
      if (val instanceof String) {
        this.initPage = JSON.parse(val)
      } else {
        this.initPage = val
      }

      this.queryItemList()
    },
    deleteFilterPresets(val) {
      this.$confirm(this.$t('Confirm Delete') + '?').then(_ => {
        let data = {
          id: val.id
        }
        this.filterLoading = true
        deleteFilterSearchForm(data).then(json => {
          if (json.data.flag === 'T') {
            this.$message({
              message: i18n.$t('Success'),
              type: 'success'
            })
            getFilterSearchForm().then(json => {
              this.initFilterTags()
            })
          }
        }).finally(_ => {
          this.filterLoading = false
        })
      }).catch(_ => {
      });
    },
    createFilterPresets() {
      // 校验是否登录
      if (!this.$store.getters.getLogin) {
        this.$message.error(this.$t('Login Required'));
        return
      } else {
        this.createFilterVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      }
    },
    cancelInputConfirm() {
      this.filterPresetsName = ''
      this.createFilterVisible = false
    },
    handleInputConfirm() {
      let data = {
        filterName: this.filterPresetsName,
        searchForm: JSON.stringify(this.initPage)
      }
      this.filterLoading = true
      saveFilterSearchForm(data).then(json => {
        if (json.data.flag === 'T') {
          this.createFilterVisible = false;
          this.filterPresetsName = '';
        }
      }).finally(_ => {
        this.filterLoading = false
      })
    },
    formatterWear(val) {
      return formatterWear(val);
    },
    formatterRarity(val) {
      return formatterRarity(val)
    },
    routerChanger(url) {
      if (/^https?:/.test(url)) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    },
    formatterSkinPortUrl(item) {
      let router = `https://skinport.com/zh${item.game === 'csgo' ? '/' : '/'+item.game+'/'}market?search=${item.engName}&sort=price&order=asc&r=hangknife`
      // let router = `https://skinport.com/r/hangknife/market?search=${item.engName}&sort=price&order=asc`
      return router
    },
    formatterDmarketUrl(item) {
      let router = `https://dmarket.com/zh/ingame-items/item-list/${item.game}-skins?ref=fDuhF5X91i&title=${item.engName}`;
      let exteriorArr = item.engName.match(/\(([^)]*)\)/)
      if (exteriorArr != undefined) {
        let exterior = exteriorArr[1]
        switch (exterior) {
          case 'Factory New':
            router += "&exterior=factory new"
            break
          case 'Minimal Wear':
            router += "&exterior=minimal wear";
            break
          case 'Field-Tested':
            router += "&exterior=field-tested";
            break
          case 'Well-Worn':
            router += "&exterior=well-worn";
            break
          case 'Battle-Scarred':
            router += "&exterior=battle-scarred";
            break
          default:
            break;
        }
        if (item.engName.indexOf('StatTrak™') !== -1) {
          router += '&category_0=stattrak_tm'
        } else {
          router += '&category_0=not_stattrak_tm'
        }
      }
      return router
    },
    formatterCsgoBuyUrl(item){
      switch (item.game){
        case "csgo":
          window.open('https://market.csgo.com/en/'+item.engName)
          break;
        case "rust":
          window.open('https://rust.tm/?t=all&search='+item.engName+'&sd=desc')
          break;
        case "dota2":
          window.open('https://market.dota2.net/?search='+item.engName+'&sd=desc')
          break;
      }
    },
    queryItemsFromAllPlatform(props) {
      let data = {
        limit: props.row.limit,
        offset: props.row.offset,
        engName: props.row.engName
      }
      props.row.loading = true
      queryItemsFromAllPlatform(data).then(json => {
        props.row['wearTable'] = json.data.list
        props.row.total = json.data.total
      }).finally(_ => {
        props.row.loading = false
      })
    },
    changeWearTablePage(props, $event) {
      props.row.offset = $event
      let data = {
        limit: props.row.limit,
        offset: props.row.offset,
        engName: props.row.engName
      }
      props.row.loading = true
      queryItemsFromAllPlatform(data).then(json => {
        props.row['wearTable'] = json.data.list
        props.row.total = json.data.total
      }).finally(_ => {
        props.row.loading = false
      })
    },
    changeWearTableSort(props, $event) {
      let data = {
        order: $event.prop + "," + $event.order,
        limit: props.row.limit,
        offset: props.row.offset,
        engName: props.row.engName
      }
      queryItemsFromAllPlatform(data).then(json => {
        props.row['wearTable'] = json.data.list
        props.row.total = json.data.total
      }).finally(_ => {
        props.row.loading = false
      })
    },
    destoryEcharts() {
      this.detailEcharts.clear();
      this.priceEcharts.clear();
    },
    initActiveWeaponType() {
      this.activeWeaponCaseType = '普通'
    },
    changeOrder({ prop, order }) {
      // 保存排序状态
      this.sortState.prop = prop;
      this.sortState.order = order;

      // 构建排序规则
      this.buildOrderBy();

      // 重新查询数据
      this.queryItemList();
    },
    buildOrderBy() {
      let orderBy = '';

      // 如果有排序状态，追加排序规则
      if (this.sortState.prop && this.sortState.order) {
        orderBy = `${this.sortState.prop},${this.sortState.order}`
      }

      this.initPage.orderBy = orderBy;
    },
    queryItemList() {
      this.loading = true;
      this.initPage.game = this.game;
      let temp = cloneObj(this.initPage)
      delete temp.total
      let sign = this.generateSignature(temp)
      temp.sign = sign
      queryItemList(temp).then(json => {
        this.staffList = json.data.rows;
        this.initPage.total = json.data.total;
      }).finally(_ => {
        this.loading = false;
      });
    },
    changePage(val) {
      this.initPage.offset = val
      this.queryItemList()
    },
    changeSize(val) {
      this.initPage.limit = val
      this.queryItemList()
    },
    formatterShortenStaffName(val) {
      let input;
      if (this.$i18n.locale === 'zh') {
        input = val.cnName == null ? val.engName : val.cnName
      } else {
        input = val.engName
      }
      return input
    },
// 生成签名
    generateSignature(params) {
      const sortedParams = {};
      Object.keys(params).sort().forEach(key => {
        if (key !== 'sign') {
          sortedParams[key] = params[key];
        }
      });

      let paramString = '';
      Object.keys(sortedParams).forEach(key => {
        const value = sortedParams[key];
        let processedValue = value;
        if (Array.isArray(value)) {
          if (value.length === 0) {
            processedValue = '[]';
          } else {
            processedValue = `[${value.join(', ')}]`;
          }
        }
        paramString += `${key}=${processedValue}&`;
      });

      // 使用RSA私钥对参数进行签名
      const encrypt = new JSEncrypt();
      encrypt.setPrivateKey(RSA_PRIVATE_KEY);
      const signature = encrypt.sign(paramString, CryptoJS.SHA256, "sha256");

      return signature;
    },
    triggerKeyDown(e) {
      if (e.keyCode === 13) {
        this.queryItemList()
      }
    },
    clickRemoteOption() {
      this.initPage.engNames = []
      this.initPage.offset = 1
      this.queryItemList()
    },
    onKeyDown($event) {
      this.initPage.engNames = []
      if ($event.keyCode == 13) {
        this.queryItemList()
      }
    },
    remoteMethod(val, cb) {
      remoteSearchOptions({name: val, game: this.game}).then(json => {
        for (let option of json.data) {
          option.value = option.cnName
        }
        cb(json.data)
      })
    },
    unlockMore(){
      this.$emit('unlockMore')
    },
    choosePlatform(val) {
      let arr = []
      this.initPage.platform = arr.concat(val)
      this.queryItemList()
    },
    resetInitPage() {
      let arr = []
      switch (this.game) {
        case "csgo":
          arr = ["BUFF", "DMarket", "C5Game", "SkinPort", "UUPIN","Eco", "CsMoney","SkinBaron","LisSkins","Csfloat"]
          break;
        case "dota2":
          arr = ["DMarket", "C5Game", "SkinPort", "IGXE","Eco", "LisSkins", "Waxpeer","CsgoBuy"]
          break;
        case "rust":
          arr = ["C5Game" ,"SkinPort","DMarket", "IGXE", "Waxpeer","RustSkins","CsgoBuy"]
          break;
        default:
          arr = []
      }

      this.initPage = {
        comparePlatform : 'BUFF_BUYER_PRICE',
        wearType: '',
        weaponCase: [],
        stickerCapsule: [],
        orderBy: 'profitRate,descending',
        name: '',
        minPrice: '100',
        maxPrice: '',
        minProfitRate: '',
        maxProfitRate: '',
        total: 0,
        limit: 10,
        offset: 1,
        steamLatestTradeCount: '',
        platform: arr
      }
      this.queryItemList()
    },
  },
  created() {
    if (this.game === 'csgo') {
      this.width = 78
    } else {
      this.width = 85
    }
    this.getUrlParameter()
    this.switchOrderOptions()
    this.resetInitPage()
  },
  mounted() {
    this.favorites = JSON.parse(localStorage.getItem('favorites')) || []
  }
}
</script>

<style scoped>
.routerLink {
  width: 175px;
  margin-bottom: 4px !important;
}

.routerLink a {
  text-decoration: none;
  color: #0d6efd;
}

.lowerDisCount {
  color: green !important;
}

.el-link {
  font-size: 13px;
}

.tagClass {
  font-size: 12px;
  display: inline-block;
  height: 18px;
  white-space: nowrap;
}

.el-icon-data-line:hover {
  cursor: pointer;
}

.updateTimeTitle {
  min-width: 85px;
  font-size: 12px;
  color: #aaaaaa;
}

.badgeItem {
  margin-top: 10px;
  margin-right: 40px;
}

.clickBtn:hover {
  cursor: pointer;
}

.dailyTrade {
  padding: 0;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 20%;
}

.el-icon-warning-outline:hover {
  cursor: pointer;
}

.hoverBtn:hover {
  cursor: pointer;
}

.hoverBtn {
  white-space: nowrap;
  overflow: hidden;
  max-width: 188px;
  text-overflow: ellipsis;
}

.detailSpan {
  margin-left: 24px;
  font-size: 12px;
}

.detailSpan:hover {
  cursor: pointer;
}

.weaponbox_rarity_title {
  text-align: center;
  color: #fff;
  height: 24px;
  line-height: 24px;
}


.image-container {
  position: relative;
  text-align: center;
  background: url(./background.jpg) 50% no-repeat;
  background-size: cover;
  height: 75px;
}

.disCount_tag {
  position: relative;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  border-radius: 2px;
  padding: 2px 6px;
  background-color: #fff;
  border-color: currentColor;
}


.priceTag {
  min-width: 52px;
  margin: 0 4px;
  text-align: center;
}


@font-face {
  font-family: "iconfont"; /* Project id 4419046 */
  src: url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff2?t=1720492860286') format('woff2'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff?t=1720492860286') format('woff'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.ttf?t=1720492860286') format('truetype'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.svg?t=1720492860286#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-dmarket:before {
  content: "\e6d5";
}

.icon-skinport:before {
  content: "\e6d1";
}

.icon-waxpeer:before {
  content: "\e6d7";
}

.icon-csmoney:before {
  content: "\e6d4";
}

.icon-steam:before {
  content: "\e6c3";
}

.icon-c5:before {
  content: "\e6c4";
}

.icon-buff:before {
  content: "\e6c5";
}

.icon-youpin:before {
  content: "\e6c6";
}

.favorite-button {
  position: absolute;
  width: 21px;
  top: 0px;
  height: 20px;
  margin-top: 2px;
  opacity: 0.3;
  left: 0px;
  cursor: pointer;
  border: none;
}

.favorite-button i {
  font-size: 20px;
  color: #ccc;
  transition: color 0.3s ease;
}

/* 最优价格样式 */
.best-price .platform-abbr {
  color: #E6A23C;
}

.best-price .diff-value {
  color: #E6A23C;
  font-weight: bold;
}

/* 正差价（高于最低价） */
.positive-diff .diff-value {
  color: #F56C6C;
}

/* 负差价（低于最低价，理论上不存在） */
.negative-diff .diff-value {
  color: #67C23A;
}

.arbitrage-hint {
  margin-top: 6px;
}

/* 布局 */
.page-container {
  padding: 12px;
}
.search-bar {
  margin-bottom: 16px;
}
.search-row {
  height: 32px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-left {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}
.search-right {
  display: flex;
  align-items: center;
}

/* 输入框 */
.select-platform {
  width: 180px;
}
.select-case {
  width: 260px;
}
.select-wear,
.select-rarity {
  width: 121px;
}
.select-quality,
.select-category {
  width: 110px;
}
.input-search {
  width: 600px;
}
.price-search-group {
  width: 600px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.input-volume {
  width: 145px;
}
.input-profit {
  width: 120px;
}
.input-price {
  width: 100px;
}

/* 快捷筛选 */
.quick-filter {
  display: flex;
  align-items: center;
}
.filter-label {
  background: #fff;
  border-color: #fff;
  margin-right: 8px;
}
.hover-btn {
  cursor: pointer;
}

/* 表格 */
.table-container {
  margin-bottom: 16px;
}
.skeleton-group {
  margin-bottom: 12px;
}
.item-img {
  width: 90px;
}
.image-container {
  position: relative;
}
.wear-tag {
  position: absolute;
  bottom: -2px;
  left: -1px;
}
.favorite-btn {
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
}

/* 名称单元格 */
.name-cell {
  font-size: 12px;
}
.name-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}
.name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.souvenir {
  color: rgb(230, 162, 60);
}
.tag-group {
  color: #8e9191;
  line-height: 14px;
  margin: 8px 0;
  display: flex;
  gap: 8px;
}
.case-info {
  display: flex;
  align-items: center;
  height: 23px;
  font-size: 12px;
  color: #aaaaaa;
  gap: 4px;
}

/* 价格样式 */
.price-bg {
  background: rgb(244, 244, 245);
  padding: 2px 4px;
}
.price-text {
  color: rgb(144, 147, 153);
}
.highlight {
  color: #E6A23C;
}
.no-data {
  font-size: 12px;
  color: #aaaaaa;
}

/* 支付方式 */
.pay-type-group {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 13px;
}
.pay-title {
  margin-right: 8px;
}

/* 选项 */
.option-small {
  font-size: 12px;
}
.option-item {
  display: flex;
  justify-content: space-between;
}
.option-only {
  color: #8492a6;
  font-size: 12px;
  cursor: pointer;
}
.wear-color-block {
  margin-right: 8px;
  display: inline-block;
  color: white;
  padding: 2px;
  min-width: 4px;
}

/* 分页 */
.pagination-container {
  padding: 20px 0 10px;
  text-align: center;
}

/* 弹窗 */
.dialog-title {
  font-weight: 600;
  font-size: 18px;
  position: relative;
}
.type-tabs {
  position: absolute;
  top: -2px;
  margin-left: 14px;
}
.rarity-title {
  text-align: center;
  padding: 4px 0;
  font-weight: 500;
}
.case-img {
  height: 40px;
}
.price-group {
  display: flex;
}
.price-item {
  display: inline-block;
  margin-right: 12px;
  min-width: 90px;
  text-align: center;
}
.exterior {
  font-size: 13px;
}
.rare-item-header {
  display: flex;
  height: 49px;
  width: 100%;
  align-items: center;
}
.gold-icon {
  width: 90px;
  height: 49px;
  padding: 0 10px;
}

/* 比价 */
.compare-cell {
  padding: 4px 0;
}
.steam-row,
.price-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.label {
  min-width: 60px;
}
.single-compare {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-select {
  width: 115px;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/ui/HomePage/homePageTable.vue